import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import LoaderButton from "@/components/shared/LoaderButton";
export type PopupProps = {
  show: boolean;
  header: string | React.ReactNode;
  secondHeader?: string | React.ReactNode;
  subHeader?: React.ReactNode;
  headeIconButtons?: React.ReactNode;
  size?: "sm" | "lg" | "xl" | undefined;
  onClose: () => void;
  hasButton?: boolean;
  buttonText?: string | React.ReactNode;
  onButtonClick?: () => void;
  submitFormId?: string | undefined;
  submitButtonText?: string | React.ReactNode;
  submitButtonLoading?: boolean;
  submitButtonLoadingText?: string;
  secondButtonText?: string;
  onSecondButtonClick?: () => void;
  backButtonText?: string | React.ReactNode;
  onBackButtonClick?: () => void;
  additionalFooterButton?: React.ReactNode;
  leftFooterButton?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  canEdit?: boolean;
  enforceFocus?: boolean;
};
export default function Popup({
  show,
  header,
  secondHeader,
  subHeader,
  headeIconButtons,
  size,
  onClose,
  hasButton = true,
  buttonText = "Save",
  onButtonClick = () => {},
  submitFormId = undefined,
  submitButtonText = "Submit",
  submitButtonLoading = false,
  submitButtonLoadingText = "Saving...",
  secondButtonText = "Close",
  onSecondButtonClick,
  backButtonText = "Back",
  onBackButtonClick,
  additionalFooterButton,
  leftFooterButton,
  className,
  style,
  children,
  canEdit = true,
  enforceFocus = true,
}: PopupProps) {
  const handleButtonClick = () => {
    onButtonClick();
  };
  const handleSecondButtonClick = () => {
    if (onSecondButtonClick) onSecondButtonClick();
    onClose();
  };
  const hasSubmitFormButton = submitFormId !== undefined;
  return (
    <Modal
      show={show}
      onHide={onClose}
      size={size}
      className={className}
      style={style}
      scrollable
      centered
      enforceFocus={enforceFocus}
    >
      <div className="modal-header d-block">
        <div className="d-flex align-items-start justify-content-between">
          {typeof header === "string" ? (
            <div className="modal-title h5 mb-0">{header}</div>
          ) : (
            <div className="flex-grow-1">{header}</div> // Header is a ReactNode
          )}
          <div>
            {headeIconButtons}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
              style={{
                filter: "invert(1) grayscale(100%) brightness(200%)",
                opacity: 1,
              }}
            ></button>
          </div>
        </div>
        {secondHeader &&
          (typeof secondHeader === "string" ? (
            <div className="modal-title h5 mb-0">{secondHeader}</div>
          ) : (
            <div className="flex-grow-1">{secondHeader}</div> // Header is a ReactNode
          ))}
      </div>
      {subHeader}
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer
        style={{
          borderTop: "1px solid #dee2e6",
          boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.06)",
        }}
      >
        <div className="d-flex w-100 align-items-center">
          <div className="d-flex gap-2">
            {onBackButtonClick && (
              <Button
                variant="outline-secondary"
                onClick={onBackButtonClick}
                type="button"
              >
                {backButtonText}
              </Button>
            )}
            {leftFooterButton}
          </div>
          <div className="ms-auto d-flex gap-2">
            {additionalFooterButton}
            {onSecondButtonClick && (
              <Button variant="secondary" onClick={handleSecondButtonClick}>
                {secondButtonText}
              </Button>
            )}
            {hasButton && canEdit && (
              <Button variant="primary" onClick={handleButtonClick}>
                {buttonText}
              </Button>
            )}
            {hasSubmitFormButton && canEdit && (
              <LoaderButton
                variant="primary"
                type="submit"
                form={submitFormId}
                loading={submitButtonLoading}
                loadingText={submitButtonLoadingText}
              >
                {submitButtonText}
              </LoaderButton>
            )}
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
